import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrustHtmlPipe } from './trust-html.pipe';
import { RouterModule } from '@angular/router';
import { WindowTokenModule } from '@modules/window-token/window-token.module';
import { RedactorFieldComponent } from './redactor-field/redactor-field.component';
import { BackgroundUrlPipe } from './background-url.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { LoaderComponent } from './loader/loader.component';
import { LockScrollService } from '@app/shared/lock-scroll.service';
import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './navigation/navigation.component';
import { InlineSVGModule } from 'ng-inline-svg';
import {BsDropdownModule, ModalModule} from 'ngx-bootstrap';
import { MomentModule } from 'angular2-moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { MultipleFieldsComponent } from './multiple-fields/multiple-fields.component';
import { GoBackService } from '@app/shared/go-back.service';
import { VoucherCardComponent } from './voucher-card/voucher-card.component';
import { EmailsService } from '@app/core/services';
import { CouponsListComponent } from '@app/shared/coupons-list/coupons-list.component';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { PersonalHelpPopupComponent } from './personal-help-popup/personal-help-popup.component';
import { CouponComponent } from './coupon/coupon.component';
import { SwiperComponent } from './swiper/swiper.component';
import { CalendarComponent } from './calendar/calendar.component';
import { FullSliderComponent } from './full-slider/full-slider.component';
import { VoucherCityInputComponent } from '@app/shared/voucher-city-input/voucher-city-input.component';
import { VoucherCityRecordComponent } from './voucher-city-record/voucher-city-record.component';
import { HideTextDirective } from './hide-text.directive';
import { SocialShareComponent } from '@app/shared/social-share/social-share.component';
import { PollModalsComponent } from '@app/shared/poll-modals/poll-modals.component';

@NgModule({
  imports: [
    BsDropdownModule,
    CommonModule,
    FormsModule,
    InlineSVGModule,
    MomentModule,
    ReactiveFormsModule,
    RouterModule,
    WindowTokenModule,
    ModalModule.forRoot(),
  ],
  declarations: [
    BackgroundUrlPipe,
    TimeAgoPipe,
    TrustHtmlPipe,

    CouponsListComponent,
    FileUploadComponent,
    FooterComponent,
    ImageCropperComponent,
    ImageUploadComponent,
    LoaderComponent,
    RedactorFieldComponent,
    NavigationComponent,
    MultipleFieldsComponent,
    PageHeaderComponent,
    VoucherCardComponent,
    PersonalHelpPopupComponent,
    CouponComponent,
    SwiperComponent,
    CalendarComponent,
    FullSliderComponent,
    VoucherCityInputComponent,
    VoucherCityRecordComponent,
    HideTextDirective,
    SocialShareComponent,
    PollModalsComponent,
  ],
  exports: [
    RouterModule,

    BackgroundUrlPipe,
    TimeAgoPipe,
    TrustHtmlPipe,

    CouponComponent,
    CouponsListComponent,
    FileUploadComponent,
    FooterComponent,
    ImageCropperComponent,
    ImageUploadComponent,
    LoaderComponent,
    NavigationComponent,
    PageHeaderComponent,
    RedactorFieldComponent,
    MultipleFieldsComponent,
    VoucherCardComponent,
    PersonalHelpPopupComponent,
    SwiperComponent,
    CalendarComponent,
    FullSliderComponent,
    VoucherCityInputComponent,
    HideTextDirective,
    SocialShareComponent,
    PollModalsComponent,
  ],
  providers: [
  ],
  entryComponents: [
    PollModalsComponent,
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        GoBackService,
        LockScrollService,
        EmailsService,
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts